import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("mubfar_cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("mubfar_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1, spec = "") => {
    setItems((prev) => {
      const key = product.id || product.slug;
      const i = prev.findIndex((x) => x.key === key);
      if (i > -1) {
        const next = [...prev];
        next[i] = { ...next[i], qty: next[i].qty + qty, spec: spec || next[i].spec };
        return next;
      }
      return [
        ...prev,
        {
          key,
          product_id: product.id || product.slug,
          slug: product.slug,
          name: product.name,
          image: product.image,
          qty,
          spec,
        },
      ];
    });
    toast.success(`${product.name} added to quote cart`);
  };

  const setQty = (key, qty) =>
    setItems((prev) =>
      prev
        .map((x) => (x.key === key ? { ...x, qty: Math.max(0, qty) } : x))
        .filter((x) => x.qty > 0)
    );

  const setDims = (key, dims) => {
    const { l = "", w = "", h = "" } = dims;
    const allSet = [l, w, h].every((v) => v !== "" && v > 0);
    setItems((prev) =>
      prev.map((x) =>
        x.key === key
          ? { ...x, dims, spec: allSet ? `${l} × ${w} × ${h} cm` : x.spec }
          : x
      )
    );
  };

  const remove = (key) => setItems((prev) => prev.filter((x) => x.key !== key));
  const clear = () => setItems([]);
  const count = items.reduce((s, x) => s + x.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, setDims, remove, clear, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}
